/* eslint-disable */
(function() {
  var $ = require('jquery');

  /* jshint camelcase:false */
  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(bindControls);
  /* jshint camelcase:true */

  bindControls();

  function bindControls() {
    var $downloadbutton = $('.track-download');
    $downloadbutton.each(function(index, elem) {
      $(elem).on('click', function(e) {
        e.preventDefault();

        var docID = $(this).data('docid');
        WebService.TrackDownload(docID, function(result) {
          if (result.Data.IsVideo) {
            return;
          }

          window.location = result.Data.URL;
        });
      });
    });
  }
})();
